import PubSub from 'pubsub-js';
import { PageEvents } from './page';

import './legal-page.scss';

const COMPONENT_NAME = 'link-list';
const BEM = {
  BLOCK: COMPONENT_NAME,
};

export class LegalPage {
  constructor() {
    const self = this;

    this._vars = {
      scrollOffset: 80 + 0, // headerHeight + offset (vedi anche legal-page.scss)
    };

    this._els = {
      linkList: $(`.${BEM.BLOCK}`),
    };

    if (window.history.scrollRestoration) {
      window.history.scrollRestoration = 'manual';
    }

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      self._selectCurrentLink();
      self._scrollToChapterByAnchorLink();
      self._scrollToChapter();
    });
  }

  _selectCurrentLink() {
    const self = this;
    const currentPathSearchHash = window.location.pathname + window.location.search + window.location.hash;
    const $sidebarLink = $(`.legalpage-sidebar a[href*="${currentPathSearchHash}"]`);
    if ($sidebarLink.length > 0) {
      self._setSelectedLink($sidebarLink.first());
    }
  }

  _scrollToChapterByAnchorLink() {
    const self = this;

    // In case in the url there is a fragment corresponding to an element in the page
    // scrolls down to that element with an offset for the header
    const currentUrlFragment = window.location.hash;
    if (currentUrlFragment) {
      const $fragmentElement = $(currentUrlFragment);
      if ($fragmentElement.length > 0) {
        setTimeout(() => {
          $('html,body').animate({
            scrollTop: $fragmentElement.offset().top - self._vars.scrollOffset,
          }, 300);
        }, 1000);
      }
    }
  }

  _scrollToChapter() {
    const self = this;
    const $sidebarLink = $('.legalpage-sidebar a[href*="#"]:not([href="#"])');
    $sidebarLink.on('click', function () {
      const $link = $(this);
      self._setSelectedLink($link);
      if (window.location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && window.location.hostname === this.hostname) {
        let target = $(this.hash);
        target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - self._vars.scrollOffset,
          }, 1000);
          return false;
        }
      } else {
        window.location.href = $(this).attr('href');
      }
      return false;
    });
  }

  _setSelectedLink($link) {
    const selectedClass = 'legalpage-sidebar-selected-title';
    const $sidebarLinks = $('.legalpage-sidebar a');
    $sidebarLinks.removeClass(selectedClass);
    $link.addClass(selectedClass);
  }
}
